import { createAction, handleActions } from 'redux-actions'

/////////////////
//// Actions ////
/////////////////

const BASE_ACTION_NAME = 'notice'

export const SHOW_ERROR_POPUP: any = createAction(`${BASE_ACTION_NAME}/show_error_popup`)
export const HIDE_ERROR_POPUP: any = createAction(`${BASE_ACTION_NAME}/hide_error_popup`)

export const SHOW_MODAL_ERROR: any = createAction(`${BASE_ACTION_NAME}/show_network_erorr`)

/////////////////
//// Reducer ////
/////////////////

interface NoticeState {
  popupErrorMessage: string | null
  isShowModalError: boolean
  modalErrorMessage: string | null
}

const initialState: NoticeState = {
  popupErrorMessage: null,
  isShowModalError: false,
  modalErrorMessage: null
}

export default handleActions(
  {
    [SHOW_ERROR_POPUP]: (state: NoticeState, { payload }: any) => ({
      ...state,
      popupErrorMessage: payload
    }),

    [HIDE_ERROR_POPUP]: (state: NoticeState) => ({
      ...state,
      popupErrorMessage: null
    }),

    [SHOW_MODAL_ERROR]: (state: NoticeState, { payload }: any) => ({
      ...state,
      isShowModalError: true,
      modalErrorMessage: payload
    })
  },
  initialState
)
